var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChassis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 56.491,
    viewBox: "0 0 87 56.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-chassis-16653",
    d: "M2.046,0h2.5A2.054,2.054,0,0,1,6.6,2.05V7.436H7.8v1.4H18.96V0H38.853V8.835h9.841v-1.4h1.2V2.05A2.058,2.058,0,0,1,51.941,0h2.5a2.054,2.054,0,0,1,2.046,2.05V17.409a2.053,2.053,0,0,1-2.046,2.048h-2.5a2.057,2.057,0,0,1-2.05-2.048V12.023h-1.2v-1.4h-9.84v5.428l-3.2,4.794V35.788H30.313v37.05h2.995V74.98h1.2v1.4H48.694v-1.4h1.2v-5.39a2.055,2.055,0,0,1,2.05-2.046h2.5a2.051,2.051,0,0,1,2.046,2.046V84.95A2.055,2.055,0,0,1,54.445,87h-2.5a2.059,2.059,0,0,1-2.05-2.05V79.564h-1.2v-1.4H34.51v1.4h-1.2v2.041L31.956,83.5h-6.1l-1.352-1.89V79.564h-1.2v-1.4H7.8v1.4H6.6V84.95A2.056,2.056,0,0,1,4.549,87h-2.5A2.055,2.055,0,0,1,0,84.95V69.589a2.051,2.051,0,0,1,2.046-2.046h2.5A2.052,2.052,0,0,1,6.6,69.589v5.39H7.8v1.4h15.5v-1.4h1.2V72.837H27.5V35.788H22.153V20.846l-3.193-4.794V10.624H7.8v1.4H6.6v5.386a2.054,2.054,0,0,1-2.05,2.048h-2.5A2.053,2.053,0,0,1,0,17.409V2.05A2.054,2.054,0,0,1,2.046,0Z",
    transform: "translate(87) rotate(90)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChassis);
export default __webpack_public_path__ + "static/media/chassis.c8bfc777f7f77c9ab9565f43efc28a61.svg";
export { ForwardRef as ReactComponent };